import { render, staticRenderFns } from "./completeRegister.vue?vue&type=template&id=a30563f2&scoped=true"
import script from "./completeRegister.vue?vue&type=script&lang=js"
export * from "./completeRegister.vue?vue&type=script&lang=js"
import style0 from "./completeRegister.vue?vue&type=style&index=0&id=a30563f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30563f2",
  null
  
)

export default component.exports